export const staticRouter = [
  {
    path: '/layout/notification/inbox',
    name: 'notificationInbox',
    component: () => import('@/views/systemManage/notification/inbox.vue'),
    meta: {
      title: '站内信',
      hidden: 1,
      menuType: 'NAVIGATOR',
    },
  },
];
